import axios from '@/axios.js'

export default {
  fetchSubjects ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/lms/st/academics/subject').then((response) => {
        let resp = {}

        if (response && response.data && response.data.data) {
          commit('UPDATE_SUBJECT', response.data.data)
          resp = response.data.data
        }

        resolve(resp)
      }).catch((error) => { 
        reject(error)
      })
    })
  },

  fetchAssigned ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/lms/st/academics/subject/assigned').then((response) => {
        let resp = {}

        if (response && response.data && response.data.data) {
          commit('UPDATE_ASSIGNED', response.data.data)
          resp = response.data.data
        }

        resolve(resp)
      }).catch((error) => { 
        reject(error)
      })
    })
  },

  fetchClasses ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/lms/st/academics/class').then((response) => {
        let resp = {}

        if (response && response.data && response.data.data) {
          commit('UPDATE_CLASS', response.data.data)
          resp = response.data.data
        }

        resolve(resp)
      }).catch((error) => { 
        reject(error)
      })
    })
  },

  fetchCategories ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/lms/st/category').then((response) => {
        let resp = {}

        if (response && response.data && response.data.data) {
          commit('UPDATE_CATEGORY', response.data.data)
          resp = response.data.data
        }

        resolve(resp)
      }).catch((error) => { 
        reject(error)
      })
    })
  }
};